import axios from "axios";

const JDPARSER_URL = axios.create({
  baseURL: "http://3.228.219.77/",
  // baseURL: " https://tz7ua2yzm3.execute-api.us-east-1.amazonaws.com/dev/"
});

const RESUME_PARSER_URL = axios.create({
  baseURL: "http://50.19.87.210/",
});

const POOl_RANKING = axios.create({
  baseURL: "https://9zrwmsc2re.execute-api.us-east-1.amazonaws.com/dev/",
})

const TARM_AWS_URL = axios.create({
  baseURL: "https://lo49b35qx6.execute-api.us-east-1.amazonaws.com/dev/",
});

// export default axios.create({
//   // baseURL: "http://3.218.142.168/"
//   baseURL: "http://localhost:106/",
// });

export { JDPARSER_URL, RESUME_PARSER_URL, TARM_AWS_URL, POOl_RANKING };
